import type { LocalizedText } from '@/lib/contentService';

const WORDS_PER_MINUTE = 200;

export function countBlogWords(content: string): number {
  const text = content
    .replace(/<[^>]+>/g, ' ')
    .replace(/&[a-z#0-9]+;/gi, ' ')
    .replace(/^#{1,6}\s+/gm, '');
  return text.split(/\s+/).filter((token) => /[\p{L}\p{N}]/u.test(token)).length;
}

export function computeReadingMinutes(content: string): number {
  return Math.max(1, Math.round(countBlogWords(content) / WORDS_PER_MINUTE));
}

export function computeReadingTimeI18n(content: LocalizedText): LocalizedText {
  return {
    tr: `${computeReadingMinutes(content.tr)} dk okuma`,
    en: `${computeReadingMinutes(content.en)} min read`,
  };
}
